module.exports = __webpack_public_path__ + "static/media/screenCap2_response.083e592f.jpg";